<template>
  <div class="app-warpper" @mousedown="userInactivityCheckStart()">
    <div class="app-body" id="app-body" :class="[bodyClass, {'scrolled': isScrolled}, brandKey]">
      <div class="header_background">
        <div class="header_holder">
          <header-part id="header-part" :style="tabletAndAbove && mainColumnWidth > 0 ? {width: mainColumnWidth + 'px'} : {}"></header-part>
        </div>
      </div>
      <v-app>
        <v-content>
          <v-container fluid>
            <router-view/>
          </v-container>
        </v-content>
        <bottom-navigation v-if="mobileBigAndBelow"></bottom-navigation>
        <geolocation-message v-if="gelocationState"></geolocation-message>
        <message-dialog v-if="messageState"></message-dialog>
      </v-app>
      <footer-part></footer-part>
    </div>
  </div>

</template>

<script>
  import store from '@/store'
  import lib from '@/library'
  import moment from 'moment'

  import Screen from '@/components/mixins/Screen'
  import Branding from '@/components/mixins/Branding'

  import BottomNavigation from '@/components/layout/parts/BottomNavigation'
  import GeolocationMessage from '@/components/common/GeolocationMessage'
  import HeaderMessages from '@/components/layout/parts/HeaderMessages'
  import MessageDialog from '@/components/layout/parts/MessageDialog'
  import FooterPart from '@/components/layout/parts/FooterPart'
  import HeaderPart from '@/components/layout/parts/HeaderPart'
  import geocomply from '@/library/geocomply'
  // import mobileBridge from '@/library/mobileBridge'

  import config from '@/config'

  export default {
    mixins: [
      Screen,
      Branding
    ],

    components: {
      BottomNavigation,
      FooterPart,
      GeolocationMessage,
      HeaderMessages,
      MessageDialog,
      HeaderPart
    },

    data () {
      return {
        bodyClass: '',
        periodicalLiveEventsUpdateTimeout: undefined,
        isPeriodicalLiveEventsUpdateStarted: false,
        periodicalBOUpdateTimeout: undefined,
        periodicalBOUpdateInterval: 60000,
        periodicalLiveStreamsUpdateTimeout: undefined,
        periodicalLiveStreamsUpdateInterval: 20000,
        periodicalSessionActivityCheckInterval: 5000,
        periodicalSessionActivityCheckObj: 0,
        periodicalWalletBalanceRefreshObj: 0,
        periodicalUserInactivityLogoutObj: 0
      }
    },

    computed: {
      liveBettingDataSourceType () {
        return store.getters['livebettingState/liveBettingDataSourceType']
      },
      copyrightYear () {
        return (new Date()).getFullYear()
      },
      gelocationState () {
        return store.getters['overlayState/getGeolocationDialogState']
      },
      messageState () {
        return store.getters['overlayState/getMessageDialogState']
      },
      headerMessageState () {
        return store.getters['overlayState/getHeaderMessageState']
      },
      isOpenedFromWebView () {
        return store.getters['getIsOpenedFromWebView']
      },
      mainColumnWidth () {
        return store.getters['screenState/getMainColumnWidth']
      },
      isWebViewAndMobile () {
        return store.getters['getWebViewAndMobile']
      },
      forceLivePull () {
        // debug: allow adding the ?forcelivepull or ?livefromgeneratordebug to the url to manually switch to PULL mode
        return this.$route.query.forcelivepull !== undefined || this.$route.query.livefromgeneratordebug !== undefined
      },
      forceLivePush () {
        // debug: allow adding the ?forcelivepush to the url to manually switch to PULL mode
        return this.$route.query.forcelivepush !== undefined
      },
      sessionDetails () {
        return store.getters['getSessionDetails']
      },
      isLoggedIn () {
        return store.getters['isLoggedIn']
      },
      mockupGeoComply () {
        return window.ctsautoconf.MOCKUP_GEOCOMPLY
      }
    },

    methods: {
      createBodyClass (routerObject) {
        var userAgentClasses = [
          'browser-'.concat(lib.core.userAgent.browser.name),
          'browser-version-'.concat(lib.core.userAgent.browser.version),
          'os-'.concat(lib.core.userAgent.os.name),
          'os-version-'.concat(lib.core.userAgent.os.version)
        ].join(' ')

        this.bodyClass = 'url-state-name-' + routerObject.name + ' ' + lib.core.url.convertUrlToClasses(routerObject.path) + ' ' + userAgentClasses
      },
      getAccountDetails () {
        store.dispatch('getAccountDetails')
      },
      getPersonalDetails () {
        store.dispatch('getPersonalDetails')
      },
      getWalletBalance () {
        store.dispatch('getWalletBalance')
      },
      fetchIgtcLastLoginDetails () {
        store.dispatch('fetchIgtcLastLoginDetails')
      },
      sessionCheck () {
        store.dispatch('getAccountDetails').then(() => {
           // MM session is present
          this.getPersonalDetails()
          this.getWalletBalance()
          if (store.state.optionalEnvironment.includes(process.env.NODE_ENV)) {
            !process.env.MOCKUP_GEOCOMPLY ? this.startGeocomply() : store.commit('setGeolocated', JSON.parse(localStorage.getItem('gcPerm')))
          } else {
            this.startGeocomply()
          }
        }).catch((response) => {
          if (response.exceptionType && response.exceptionType === 'Com.Finsoft.Warp.Connecticut.SessionTimeoutException') { // MM session is not present, checking for external
            if (this.isOpenedFromWebView) {
              document.getElementById('app').classList.add('mobile-app-overlay')
            }
            store.dispatch('validateSession').then(() => {
              if (this.isOpenedFromWebView) {
                document.getElementById('app').classList.remove('mobile-app-overlay')
              }
              this.getAccountDetails()
              this.getPersonalDetails()
              this.getWalletBalance()
              this.startGeocomplyFromCasino()
            }).catch(() => { // External session is not present
              store.dispatch('clearAccountDetails')
              console.log('Validate session failed.')
              if (this.isOpenedFromWebView) {
                document.getElementById('app').classList.remove('mobile-app-overlay')
              }
            })
          }
        }).finally(() => {
        })
      },
      igtConnectCheckSession () {
        store.dispatch('getAccountDetails').then(() => {
          // MM session is present
          this.getPersonalDetails()
          this.getWalletBalance()
          this.fetchIgtcLastLoginDetails()
          store.dispatch('mobileGeolocated')
          if (this.mockupGeoComply !== undefined && (!this.isOpenedFromWebView && !this.webViewAndMobile)) {
            if (this.mockupGeoComply) {
              store.commit('setGeolocated', JSON.parse(localStorage.getItem('gcPerm')))
            }
            if (!this.mockupGeoComply) {
              this.startGeocomply()
              this.repeatGeolocationProcess()
            }
          } else {
            this.startGeocomply()
            this.repeatGeolocationProcess()
          }
        }).catch((response) => {
          if (response.exceptionType && response.exceptionType === 'Com.Finsoft.Warp.Connecticut.SessionTimeoutException') { // MM session is not present, checking for external
            if (this.isOpenedFromWebView) {
              document.getElementById('app').classList.add('mobile-app-overlay')
            }
            store.dispatch('clearAccountDetails')
            store.dispatch('mobileGeolocated')
            console.log('Session timeout.')
            if (this.isOpenedFromWebView) {
              document.getElementById('app').classList.remove('mobile-app-overlay')
            }
          }
        })
      },
      setLiveBettingDataSourceType (value) {
        store.commit('livebettingState/setLiveBettingDataSourceType', value)
      },

      startLiveEventsPeriodicalUpdate () {
        var self = this
        self.lib = lib
        this.isPeriodicalLiveEventsUpdateStarted = true

        if (!this.liveBettingDataSourceType && !this.forceLivePull) {
          store.dispatch('livebettingState/calculateLocalClockOffsetInSeconds').then(() => {
            this.setLiveBettingDataSourceType('PUSH')

            self.lib.WebSocketLiveService.startService(() => {
              console.log('WebSocketService - Cannot connect to server. Switching to PULL mode')
              this.setLiveBettingDataSourceType('PULL')
              self.startLiveEventsPeriodicalUpdate()
            })
          })
        } else if (this.liveBettingDataSourceType === 'PUSH') {
          // DO nothing. It will work by magic :)
        } else if (this.liveBettingDataSourceType === 'PULL' || this.forceLivePull) {
          store.dispatch('livebettingState/fetchLiveEvents', {
            eventsperpage: 200,
            page: 1,
            maxnumofselectionsperevent: 6,
            flags: 'SHOWONFILTER' }).then(() => {
              this.setLiveBettingDataSourceType('PULL')
              clearTimeout(self.periodicalLiveEventsUpdateTimeout)
              self.periodicalLiveEventsUpdateTimeout = setTimeout(() => {
                if (self.isPeriodicalLiveEventsUpdateStarted) {
                  self.startLiveEventsPeriodicalUpdate()
                }
              }, 5000)
            })
        }
      },
      stopLiveEventsPeriodicalUpdate () {
        this.isPeriodicalLiveEventsUpdateStarted = false
        clearTimeout(this.periodicalLiveEventsUpdateTimeout)
        this.lib.WebSocketLiveService.stopService()
        this.setLiveBettingDataSourceType('')
      },
      startLiveStreamsUpdate () {
        store.dispatch('livebettingState/fetchLiveStreams', { idfoevent: 'ALL', streamtype: 'ALL' }).then(() => {
          clearTimeout(this.periodicalLiveStreamsUpdateTimeout)
          this.periodicalLiveStreamsUpdateTimeout = setTimeout(() => {
            this.startLiveStreamsUpdate()
          }, this.periodicalLiveStreamsUpdateInterval)
        })
      },
      stopLiveStreamsUpdate () {
        clearTimeout(this.periodicalLiveStreamsUpdateTimeout)
      },
      startBoNavigationUpdate () {
        store.dispatch('bonavigationState/fetchBoNavigation').then(() => {
          clearTimeout(this.periodicalBOUpdateTimeout)
          this.periodicalBOUpdateTimeout = setTimeout(() => {
            this.startBoNavigationUpdate()
          }, this.periodicalBOUpdateInterval)
        })
      },
      fetchSiteNavigation () {
        store.dispatch('siteNavigationState/fetchSiteNavigation')
      },
      fetchBoNavigationHeadlines () {
        store.dispatch('bonavigationState/fetchBoNavigationHeadlines')
      },
      startGeocomply () {
        let userID = config.customCookies.getCookie('sessionDetails').geolocationUserId
        let webViewAndMobile = store.getters['getWebViewAndMobile']
        store.commit('setGeolocated', JSON.parse(localStorage.getItem('gcPerm')))
        let isGeolocated = JSON.parse(localStorage.getItem('gcPerm'))
        if (!webViewAndMobile && !this.isOpenedFromWebView && isGeolocated) {
          console.log('on refresh start geolocation')
          let currentTime = moment()
          let storedTime = JSON.parse(localStorage.getItem('tgc')).date
          let checkFor = JSON.parse(localStorage.getItem('tgc')).cf
          let diffTime = moment.duration(currentTime.diff(storedTime)).asMilliseconds()
          if (diffTime > checkFor) {
            console.log('bigger')
            geocomply.geoComplyService(userID, false, 'Periodic')
          } else if (diffTime < checkFor) {
            console.log('smaller')
            let getDiff = checkFor - diffTime
            setTimeout(() => {
              geocomply.geoComplyService(userID, false, 'Periodic')
            }, getDiff)
          }
        }
      },
      startGeocomplyFromCasino () {
        let sessionDetails = config.customCookies.getCookie('sessionDetails')
        let userID = sessionDetails.playerUid
        let webViewAndMobile = store.getters['getWebViewAndMobile']
        store.commit('setGeolocated', JSON.parse(localStorage.getItem('gcPerm')))
        let isGeolocated = JSON.parse(localStorage.getItem('gcPerm'))
        if (!webViewAndMobile && !this.isOpenedFromWebView && (!isGeolocated || isGeolocated === null)) {
          geocomply.geoComplyService(userID, 'Login')
        }
      },
      softGeolocation () {
        if (window.ctsautoconf.SOFTGEOLOCATION && window.ctsautoconf.STATE === 'NJ') {
          setTimeout(() => {
            if (!this.isOpenedFromWebView && !this.isLoggedIn) {
              store.dispatch('softGeolocation')
            }
          }, 1000)
        }
      },
      setHeaderSettings () {
        setTimeout(() => {
          if (!this.isOpenedFromWebView && this.mobileBigAndBelow) {
            store.commit('overlayState/setHeaderMessageState', true)
            store.commit('setWebViewAndMobile', true)
            store.commit('overlayState/setHeaderMessagesData', {'style': 'white'})
          }
        }, 500)
      },
      networkStatus () {
        if (!this.isOpenedFromWebView) {
          window.addEventListener('online', () => {
            setTimeout(() => (
              document.location.reload(true)
            ), 10000)
          })
        }
      },
      // mobileBridge () {
      //   setTimeout(() => {
      //     if (this.isOpenedFromWebView) {
      //       mobileBridge.init()
      //     }
      //   }, 1000)
      // },
      periodicalSessionActivityCheckStart () {
        var self = this
        clearTimeout(this.periodicalSessionActivityCheckObj)

        this.periodicalSessionActivityCheckObj = setTimeout(() => {
          let seslimits = store.getters['accountState/getLimits4Session']

          if (seslimits === null || seslimits.singleSessionLimit === null) {
            store.dispatch('accountState/fetchLimits4Session', {
            }).then(() => {
              self.periodicalSessionActivityCheckStart()
            }).catch(() => {
              self.periodicalSessionActivityCheckStart()
            })
          } else {
            // check session length to be in limit
            let sesDur = Math.abs(Date.now() - localStorage.loginTime)
            // console.log('periodicalSessionActivityCheckStart : 2 : ' + seslimits.singleSessionLimit + ' : ' + sesDur + ' : ' + (sesDur / 1000))
            if (sesDur >= seslimits.singleSessionLimit && seslimits.singleSessionLimit > 0) {
              store.commit('overlayState/setMessageDialogMsg', {
                reason: 'common',
                reasonTitle: 'Session limit reached',
                reasonDescription: 'Your single session time is over the limits. You will be logged out automatically.',
                persistent: true,
                fullscreen: false,
                onCloseAction: 'logout'
              })
              store.dispatch('overlayState/activateMessageDialog')
            } else {
              self.periodicalSessionActivityCheckStart()
            }

            // TODO: Periodical session check. Uncomment once the method starts working on IGTC
            //  store.dispatch('igtcCheckSession').then(() => {
            //    self.periodicalSessionActivityCheckStart()
            //  }).catch((error) => {
            //    if (this.isLoggedIn) {
            //      console.log(error)
            //      store.dispatch('logout')
            //    }
            //  })
          }
        }, this.periodicalSessionActivityCheckInterval)
      },
      periodicalSessionActivityCheckStop () {
        clearTimeout(this.periodicalSessionActivityCheckObj)
      },
      periodicalWalletBalanceRefreshStart () {
        clearTimeout(this.periodicalWalletBalanceRefreshObj)
        this.periodicalWalletBalanceRefreshObj = setTimeout(() => {
          if (this.isLoggedIn) {
            this.getWalletBalance()
            this.periodicalWalletBalanceRefreshStart()
          }
        }, config.app.autoconf.PERIODICAL_BALANCE_REFRESH_INTERVAL || 59000)
      },
      periodicalWalletBalanceRefreshStop () {
        clearTimeout(this.periodicalWalletBalanceRefreshObj)
      },
      repeatGeolocationProcess () {
        setTimeout(() => {
          let userID = config.customCookies.getCookie('sessionDetails').geolocationUserId
          let geolocationInProgress = sessionStorage.getItem('geolocationInProgress')
          if (geolocationInProgress !== null && this.isLoggedIn) {
            console.log('repeatGeolocationProcess')
            geocomply.geoComplyService(userID, false, geolocationInProgress)
          }
        }, 1000)
      },
      userInactivityCheckStart () {
        clearTimeout(this.periodicalUserInactivityLogoutObj)
        if (this.isLoggedIn) {
          console.log('userActivity - started')
          this.periodicalUserInactivityLogoutObj = setTimeout(() => {
            this.$router.push('/logout')
          }, (config.app.autoconf.USER_INACTIVITY_LOGOUT_INTERVAL || 1800000))
        }
      },
      userInactivityCheckStop () {
        console.log('userActivity - stopped')
        clearTimeout(this.periodicalUserInactivityLogoutObj)
      }
    },

    created () {
      // store.dispatch('sbBetslipState/fetchBettingParams')
    },

    mounted () {
      // store.commit('sbBetslipState/getConfig')
      this.fetchSiteNavigation()
      this.fetchBoNavigationHeadlines()
      this.startBoNavigationUpdate()
      this.createBodyClass(this.$route)
      // if (config.app.autoconf.EXTERNAL_WALLET_PROVIDER === 'IGTC') {
      //   this.igtConnectCheckSession()
      // } else {
      //   this.sessionCheck()
      // }

      // this.softGeolocation() - TODO - Uncomment when Geolocation should be enabled

      if (this.forceLivePush) {
        this.setLiveBettingDataSourceType(null)
      }
      this.startLiveEventsPeriodicalUpdate()
      // this.startLiveStreamsUpdate()

      this.setHeaderSettings()
      this.networkStatus()
      // this.mobileBridge()
    },

    destroyed () {
      this.stopLiveEventsPeriodicalUpdate()
      // this.stopLiveStreamsUpdate()
    },

    watch: {
      '$route' (to, from) {
        this.createBodyClass(to)
      },
      isLoggedIn (newValue) {
        if (config.app.autoconf.EXTERNAL_WALLET_PROVIDER === 'IGTC') {
          if (newValue) {
            this.periodicalWalletBalanceRefreshStart()
            this.periodicalSessionActivityCheckStart()
            this.userInactivityCheckStart()
          } else {
            this.periodicalWalletBalanceRefreshStop()
            this.periodicalSessionActivityCheckStop()
            this.userInactivityCheckStop()
          }
        }

        if (!newValue) {
          store.dispatch('accountState/resetAccountStates', {})
        }
      }
    },

    name: 'App'
  }
</script>

<style lang="stylus">
  @import './css/main'

  .header_background
    width: 100%
    position fixed
    top 0
    z-index 7

</style>



// WEBPACK FOOTER //
// src/App.vue